<template style="height:100%">
  <div class="Scblock">
      <div class="acc">
        <el-row>
          <el-button type="primary">创建套餐</el-button>
          <el-button type="primary" plain>发布套餐</el-button>

          <el-input class="search"  placeholder="搜索功能关键字" prefix-icon="el-icon-search">
          </el-input>
          <el-button class="search_btn" type="primary">搜索</el-button>
        </el-row>
      </div>
      <div class="Scblock_ts">
          <h2>量表分类</h2>
          <h3>量表列表</h3>
      </div>
      <el-tabs :tab-position="tabPosition" style="height: 100%;text-align: left!important; ">
        <el-tab-pane label="用户管理">
          <div class="Scblock_ts_s">
            <h2>选择</h2>
            <h3>量表名称</h3>
            <h4>量表描述</h4>
          </div>
          <ul class="dvdvvd" style="margin-top: 20px;">
            <li>
              <div class="SCL">
                <el-checkbox-group v-model="checkboxGroup1" size="small">
                  <el-checkbox  label="90项症状清单（SCL90）">90项症状清单（SCL90）</el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="describe">
                你是否感到身体有问题？你是否容易烦恼和激动？SCL－广泛应用于我国的心理咨询中，它是目前我国使用最广的一种检查心理健康的量表。从感觉、情感、思维、意识、行为直至生活习惯等方面综合测查你的心理健康水平，帮助你及时了解自己的心理和身体情况。
              </div>
            </li>
             <li>
              <div class="SCL">
                <el-checkbox-group v-model="checkboxGroup1" size="small">
                  <el-checkbox  label="焦虑自评量表（SAS）">焦虑自评量表（SAS）</el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="describe">
                焦虑是包涵了担心、紧张和恐惧并伴随心跳加快等不适症状的一种情绪。想了解自己在多大程度上想做的事情做不了？或者该做的事情做不好？用此主观评分表来测测你的焦虑水平吧，它只有道题。
              </div>
            </li>
             <li>
              <div class="SCL">
                <el-checkbox-group v-model="checkboxGroup1" size="small">
                  <el-checkbox  label="抑郁自评量表（SDS）">抑郁自评量表（SDS）</el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="describe">
                几乎我们所有人都在某个时候觉得情绪低落，常常是因为生活中一些不如意的事情，这是正常现象。但是持续性的抑郁状态便会发展成为抑郁症。此自评量表能反映被测者的主观感受，判断出你的抑郁程度。建议结合专业人员的解释。
              </div>
            </li>
             <li>
              <div class="SCL">
                <el-checkbox-group v-model="checkboxGroup1" size="small">
                  <el-checkbox  label="贝克焦虑量表（BAI）">贝克焦虑量表（BAI）</el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="describe">
                 焦虑是人类在与环境作斗争及生存适应的过程中发展起来的基本人类情绪。但是随着生活节奏的加快，焦虑已成为现代人普遍的“心病”。过分焦虑的状态会影响我们的日常生活和身体健康，而适度的焦虑能够帮助我们更好地追求目标。本测试将根据你目前的状态评估你当前的焦虑情况，帮助你更好地有针对性地调整自己的心理状态。
              </div>
            </li>
            <li>
              <div class="SCL">
                <el-checkbox-group v-model="checkboxGroup1" size="small">
                  <el-checkbox  label="贝克焦虑f量表（BAI）">贝克焦虑量表（BAI）</el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="describe">
                 焦虑是人类在与环境作斗争及生存适应的过程中发展起来的基本人类情绪。但是随着生活节奏的加快，焦虑已成为现代人普遍的“心病”。过分焦虑的状态会影响我们的日常生活和身体健康，而适度的焦虑能够帮助我们更好地追求目标。本测试将根据你目前的状态评估你当前的焦虑情况，帮助你更好地有针对性地调整自己的心理状态。
              </div>
            </li>
            <li>
              <div class="SCL">
                <el-checkbox-group v-model="checkboxGroup1" size="small">
                  <el-checkbox  label="贝克焦虑1量表（BAI）">贝克焦虑量表（BAI）</el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="describe">
                 焦虑是人类在与环境作斗争及生存适应的过程中发展起来的基本人类情绪。但是随着生活节奏的加快，焦虑已成为现代人普遍的“心病”。过分焦虑的状态会影响我们的日常生活和身体健康，而适度的焦虑能够帮助我们更好地追求目标。本测试将根据你目前的状态评估你当前的焦虑情况，帮助你更好地有针对性地调整自己的心理状态。
              </div>
            </li>
            <li>
              <div class="SCL">
                <el-checkbox-group v-model="checkboxGroup1" size="small">
                  <el-checkbox  label="贝克焦虑s量表（BAI）">贝克焦虑量表（BAI）</el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="describe">
                 焦虑是人类在与环境作斗争及生存适应的过程中发展起来的基本人类情绪。但是随着生活节奏的加快，焦虑已成为现代人普遍的“心病”。过分焦虑的状态会影响我们的日常生活和身体健康，而适度的焦虑能够帮助我们更好地追求目标。本测试将根据你目前的状态评估你当前的焦虑情况，帮助你更好地有针对性地调整自己的心理状态。
              </div>
            </li>
          </ul>
        </el-tab-pane>





        <el-tab-pane label="配置管理">配置管理</el-tab-pane>
        <el-tab-pane label="角色管理">角色管理</el-tab-pane>
        <el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane>
        <el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane>
        <el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane>
        <el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane>
      </el-tabs>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        tabPosition: 'left',
        checkboxGroup1: [],
        checkboxGroup2: []
      };
    },
    methods: {

    }
  };
</script>
<style>
/* .about{height: 100%!important;} */
.Scblock>ul{position: relative;min-height: 650px;background-color: chocolate;height: 100%;}
.Scblock>ul>li{height: 50px;line-height: 50px;color: rgba(61, 61, 61, 1);cursor:pointer;}
.Scblock>ul>li>ul>li{background-color: chartreuse;width: 90%;min-height: 650px;position: absolute;top: 0px;right: 0px;position: relative;}
  .is-left{text-align: left;}
.Scblock .el-tabs--left .el-tabs__item.is-left {
    text-align: left!important;font-size: 14px;
}
.Scblock_ts{width: 100%;height: 40px;line-height: 40px;}
.Scblock_ts h2{width: 160px;display: inline-block;font-size: 16px;}
.Scblock_ts h3{width: 160px;display: inline-block;font-size: 16px;}
.Scblock_ts_s  h2{width: 40px;display: inline-block;font-size: 16px;margin-left: 28px;}
.Scblock_ts_s  h3{width: 230px;display: inline-block;font-size: 16px;}
.Scblock_ts_s  h4{width: 130px;display: inline-block;font-size: 16px;}
.describe{    padding: 20px 32px;border-left: #e3e3e3 1px solid;display: inline-block;max-width: 60%;line-height: 30px;margin-left: 300px;color: rgba(112, 112, 112, 1);}
.dvdvvd li{position: relative;}
.SCL{margin-top: 20px;margin-left: 27px;width:300px;display: inline-block;position: absolute;top: 20px;left: 20px;}
/* overflow : visible | auto | hidden | scroll */
</style>